<template>
	<el-popover placement="bottom" width="200" trigger="hover" :content="reason" :disabled="!reason">
		<div :class="['tag fz-12 nowrap radius-4', classStyle]" slot="reference">
			<span>{{ desc }}</span>
			<i class="el-icon-arrow-right" v-if="!!reason"></i>
		</div>
	</el-popover>
</template>
<script>
export default {
	props: {
		desc: {
			type: String,
			default: '',
		},
		reason: {
			type: String,
			default: '',
		},
		status: {
			type: [String, Number],
			default: '',
		},
	},
	computed: {
		classStyle({ status }) {
			const obj = {
				0: 'warning',
				10: 'warning',
				20: 'error',
				30: 'defalut',
				40: 'defalut',
				50: 'success',
			};
			return obj[status];
		},
	},
};
</script>
<style lang="less" scoped>
.tag {
	display: flex;
	align-items: center;
	padding: 0 4px;
	line-height: 16px;
}
.warning {
	border: 1px solid #ffe4ba;
	color: #f97a00;
}
.defalut {
	border: 1px solid #e2e3e8;
	color: @color-regular;
}
.success {
	border: 1px solid #cff1d2;
	color: @color-g;
}
.error {
	border: 1px solid #fed4d0;
	color: @color-error;
}
</style>
